import resume from '../assets/pdf/cv.pdf'
import profileImage from '../assets/images/profile.jpg'

export const headerData = {
    name: 'Algert Zharri',
    title: "Full Stack Developer",
    desciption:"Full Stack Developer who builds responsive web applications from concept to deployment. I combine React's dynamic frontend capabilities with robust Django backends to create scalable solutions.",
    image: profileImage,
    resumePdf: resume
}
